/**
 * 应用入口：必须先于 main.jsx 整棵静态 import 树执行 webkit 兜底，
 * 否则 iOS 内嵌浏览器（FB / Instagram / TikTok 等 IAB）下第三方脚本可能在守卫之前访问 window.webkit.messageHandlers。
 */
import { installWebkitBridgeGuard } from './utils/webkitBridgeGuard'

installWebkitBridgeGuard()

import('./main.jsx').catch((err) => {
  console.error('[entry] bootstrap main failed', err)
})
